import { render } from "./DialogFTColor.vue?vue&type=template&id=6a1290f2"
import script from "./DialogFTColor.vue?vue&type=script&lang=js"
export * from "./DialogFTColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__